import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ProgressService {

  public isBusy : boolean = false;

  constructor() { }
}
